import { CombinedState } from '@reduxjs/toolkit';
import { RootStateType } from 'App/store';
import { convertStatusTypeToObject } from 'commons/utils/convertStatusTypeToObject';
import { RecipientState } from '../../types';

export const getRecipientState = (
  state: RootStateType,
): CombinedState<RecipientState> => state.pagoNubeOnboarding.recipient;

export const getRecipientData = (state: RootStateType) =>
  getRecipientState(state).getRecipient.data;

export const getRecipientStatus = (state: RootStateType) => {
  const status = getRecipientState(state).getRecipient.status;
  return convertStatusTypeToObject(status);
};

export const updateRecipientData = (state: RootStateType) =>
  getRecipientState(state).updateRecipient.data;

export const updateRecipientResponseStatus = (state: RootStateType) => {
  const status = getRecipientState(state).updateRecipient.status;
  return convertStatusTypeToObject(status);
};
